// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2bKfP","buttons":"SendReceipts_buttons__2vE5T","email":"SendReceipts_email__3sser","bookApptTitle":"SendReceipts_bookApptTitle__2-j03"};